import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import type { Permesso, Sessione } from '../../lib/sessione';
import { ANONIMO, puo } from '../../lib/sessione';

/*  La sessione a disposizione di tutta l'interfaccia.

    Un contesto e non un parametro passato di mano in mano: i bottoni da nascondere
    stanno in fondo a catene di quattro o cinque componenti — elenco, scheda, pannello,
    modulo — e far attraversare la sessione a tutti vorrebbe dire toccare componenti che
    con i permessi non hanno niente a che fare, solo per farli passare.

    Il valore predefinito è la sessione anonima, che non ha nessun permesso. È la scelta
    giusta nel verso giusto: un componente montato fuori dal fornitore — in un test, o
    per una dimenticanza — mostra meno di quello che dovrebbe e non di più.

    Serve a NON mostrare comandi che il server rifiuterebbe. Non protegge niente: la
    protezione è il 403, e resta anche se qualcuno smonta l'interfaccia dal browser.
*/
const Contesto = createContext<Sessione>(ANONIMO);

export function FornitoreSessione({
  sessione,
  children,
}: {
  sessione: Sessione;
  children: ReactNode;
}) {
  return <Contesto.Provider value={sessione}>{children}</Contesto.Provider>;
}

export const useSessione = (): Sessione => useContext(Contesto);

/**
 * `const puoFare = usePuo();` e poi `puoFare('AnnullaOrdini')`. Un permesso scritto male
 * non compila, perché il tipo è l'elenco dei permessi del backend.
 */
export function usePuo(): (permesso: Permesso) => boolean {
  const sessione = useSessione();
  return useMemo(() => (permesso: Permesso) => puo(sessione, permesso), [sessione]);
}
